import {
  getShowDynamicCountdown,
  parseShowDateTimeInstant,
} from "./showDates";

/** Countdown breakdown until a CMS/GraphQL datetime instant, or false if missing/past. */
export function dayUntil(dateString) {
  if (!dateString) {
    return false;
  }

  const target = parseShowDateTimeInstant(dateString);
  if (!target) return false;

  const diff = target.getTime() - Date.now();
  if (diff <= 0) {
    return false;
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000),
  };
}

export function dayUntilFromShowStart(unformattedStartDate, startTimeHour = 0) {
  const countdown = getShowDynamicCountdown(
    unformattedStartDate,
    startTimeHour
  );
  if (countdown.days < 0) return false;
  return countdown;
}
